(function () {
  'use strict'

  var MODULE_NAME = 'thismoment.embed.component'

  require('angular')
    .module(MODULE_NAME, [
      require('./embed-playlist'),
      require('./embed-ugc')
    ])

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/embed/component/index.js